module.exports = __webpack_public_path__ + "img/lifestyle_thumbnail-600x450.92b8953f.jpg";